<div class="card">
    <div class="card-header">
        <section>
            <h2 class="card-title">Delinquency</h2>
            <p class="subtitle">Ideally only 5% of your portfolio is delinquent.</p>
        </section>        
        <h3><span class="badge badge-{{level()}}">{{percent | percent}}</span></h3>
    </div>
    <div class="card-body">
        <canvas baseChart [data]="stats" [options]="options" [type]="'bar'"> </canvas>
    </div>
    <div class="card-footer">
        @if (this.latest) {
            <p>as of {{this.latest.day | date:'E MMM d, yyyy'}}</p>
        }
    </div>
</div>